// test1587
(1587 && 0);
